import {NgModule} from '@angular/core';
import {CaptchaComponent} from "@iw-shop/captcha/componments/captcha/captcha.component";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    declarations: [
        CaptchaComponent,
    ],
    imports: [
        NgIf,
        NgClass,
        NgForOf,
        FontAwesomeModule

    ],
    exports: [
        CaptchaComponent
    ]
})
export class CaptchaModule {
}
